import React, { Component } from 'react';

import DocumentDownload from 'components/cards/document/DocumentDownload';

export default class DocumentDownloadModal extends Component {
	render() {
		const { params : document, remove } = this.props;

		return <div className="ant-modal-wrap hide">
			<DocumentDownload onDownloadStart={remove} document={document} />
		</div>;
	}
}
